<template>
  <main v-if="loggedIn === false">
    <PageIntro v-if="appLogin === false"
      :heading="'Sign in with your <span>My Latics</span> account'"
      :body="''" />

    <Login />

    <FooterShout v-if="appLogin === false" :type="'register'"/>
  </main>
</template>

<script>
  import Login from '@/components/Login'
  // import SocialSignIn from '@/components/SocialSignIn'
  import PageIntro from '@/components/PageIntro'
  import OrDivider from '@/components/OrDivider'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      // SocialSignIn,
      Login,
      PageIntro,
      OrDivider,
      FooterShout
    },
    data() {
      return {
        from: null,
        appLogin: false,
        loggedIn: true //assume they are logged in
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-login'){
        this.appLogin = true
      }
      if(this.$getAuthenticatedUser() != null) {
        this.loggedIn = true;
      }else{
        this.loggedIn = false;
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
            console.log('before route enter')
            // TODO: Make sure we handle people referred from password reset with a message on sign in page 
        });
    },
    
    
  }
</script>
